import type { ChainNetwork } from '@ducat-unit/core';

export function colorByNetwork(network: ChainNetwork | undefined) {
  switch (network) {
    case 'mutiny':
      return '#6f1d5d';
    case 'testnet4':
      return '#5fd15c';
    default:
      return '#F7931A';
  }
}
